import React, { useState } from "react";
import { useForm } from "react-hook-form";
import IconClose from "../Resources/svg/Icons/IconClose";
import Button from "./FormElements/Button";
import ErrorCustom from "./errorCustom";

export default function ModalAnulacionRV({
  open,
  setOpen,
  nroOperacion,
  onSubmitCallback,
}) {
  const { register, handleSubmit, errors, reset, watch } = useForm();
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  
  const tipoAnulacion = watch("tipoAnulacion");
  const motivoAnulacion = watch("motivoAnulacion");
  
  const isFormValid = tipoAnulacion && motivoAnulacion && motivoAnulacion.trim() !== "";

  const tiposAnulacion = [
    { id: "1", label: "A solicitud de AFP" },
    { id: "2", label: "Otros" },
  ];

  const handleClose = () => {
    reset();
    setOpen(false);
  };

  const onSubmit = async (data) => {
    setLoadingSubmit(true);
    try {
      await onSubmitCallback({
        id: nroOperacion,
        anulacion: {
          tipoAnulacion: data.tipoAnulacion,
          motivoAnulacion: data.motivoAnulacion,
        },
      });
      reset();
      setOpen(false);
    } catch (error) {
      console.error("Error en anulación:", error);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const validatorField = (value) => {
    if (!value || value.trim() === "") {
      return "Campo requerido";
    }
    return true;
  };

  return (
    <div
      className={
        "modal-filtering modal-result is-midle modal-confirmation" +
        (open ? " is-open" : "")
      }
    >
      <div className="modal-filtering__box">
        <div className="modal-filtering__close" onClick={handleClose}>
          <IconClose />
        </div>
        <div className="modal-filtering__body">
          <div className="wrap">
            <div className="modal-filterin__inner">
              <h2 className="modal-result__title">Anular Operación</h2>
              <div className="modal-result__content">
                <div className="modal-result__desc" style={{ marginBottom: "20px" }}>
                  Operación N° <strong>{nroOperacion}</strong>
                </div>
                
                <div className="clientForm__control">
                  <select
                    className="browser-default"
                    name="tipoAnulacion"
                    ref={register({ validate: validatorField })}
                    defaultValue=""
                  >
                    <option value="" disabled>
                      Seleccione tipo de anulación
                    </option>
                    {tiposAnulacion.map((tipo) => (
                      <option key={tipo.id} value={tipo.id}>
                        {tipo.label}
                      </option>
                    ))}
                  </select>
                  <ErrorCustom errors={errors} name="tipoAnulacion" />
                </div>

                <div className="clientForm__control input-field">
                  <textarea
                    id="motivoAnulacion"
                    name="motivoAnulacion"
                    className="materialize-textarea"
                    ref={register({ validate: validatorField })}
                    maxLength="500"
                  />
                  <label htmlFor="motivoAnulacion">
                    Motivo de anulación
                  </label>
                  <ErrorCustom errors={errors} name="motivoAnulacion" />
                </div>
              </div>
              
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '20px', position: 'relative' }}>
                <Button
                  onClick={handleSubmit(onSubmit)}
                  className={`${
                    loadingSubmit ? "is-loading" : ""
                  } actions__continue`}
                  disabled={loadingSubmit || !isFormValid}
                >
                  Anular
                </Button>
                <Button
                  className="is-secondary actions__cancel"
                  onClick={handleClose}
                  disabled={loadingSubmit}
                >
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
